// Object Identifiers for Intel SGX extensions
// Converted from oids.rs

const SGX_EXTENSION = "1.2.840.113741.1.13.1";
const PPID = "1.2.840.113741.1.13.1.1";
const TCB = "1.2.840.113741.1.13.1.2";
const PCEID = "1.2.840.113741.1.13.1.3";
const FMSPC = "1.2.840.113741.1.13.1.4";
const SGX_TYPE = "1.2.840.113741.1.13.1.5";
const PLATFORM_INSTANCE_ID = "1.2.840.113741.1.13.1.6";
const PCESVN = "1.2.840.113741.1.13.1.2.17";
const CPUSVN = "1.2.840.113741.1.13.1.2.18";

module.exports = {
    SGX_EXTENSION,
    PPID,
    TCB,
    PCEID,
    FMSPC,
    SGX_TYPE,
    PLATFORM_INSTANCE_ID,
    PCESVN,
    CPUSVN,
};
